import * as React from 'react';
import { isNumber } from 'lodash';

import './style.css';
import { WBIcon } from '@/core';

export interface ActivityIndicatorProps {
	/**
	 * Hexadecimal color value.
	 */
	color?: string;
	/**
	 * Component size.
	 */
	size?: 'small' | 'large' | number;
}

/**
 * Function to return size value if a string is given.
 */
const getSize = (size: 'small' | 'large' | number): number => {
	if (isNumber(size)) {
		return size;
	}

	switch (size) {
		default:
		case 'small':
			return 20;
		case 'large':
			return 30;
	}
};

const ActivityIndicator: React.FC<ActivityIndicatorProps> = ({ color, size }) => (
	<div className='ActivityIndicatorIcon'>
		<WBIcon name='loader' color={color as string} size={getSize(size)} />
	</div>
);

export default ActivityIndicator;
